import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import get from 'lodash.get';
import {
  getPartnerCouponPrice,
  checkPartnerRenderSkim,
} from '../../../../app/Helper/CouponHelper';

import PartnerBurdenText from './PartnerBurdenText';
import PartnerBurdenButton from './PartnerBurdenButton';
import PartnerBurdenToast from './PartnerBurdenToast';

/**
 * 파트너 부담 쿠폰
 * - 파트너 쿠폰에 노출될 가격 및 할인가, 스킴 여부를 프론트에서 계산중 (쿠폰 API에서 계산 부담)
 */
function CouponPartner({ coupon }) {
  const [isToast, setIsToast] = useState(false);
  const { issueCoupon } = useSelector(state => ({
    issueCoupon: state.fetchApi.issueCoupon
      ? state.fetchApi.issueCoupon.response
      : {},
  }));

  const issueCouponData = get(issueCoupon, ['data'], {});

  const price = getPartnerCouponPrice(coupon);
  const isSkim = checkPartnerRenderSkim(coupon);
  const {
    couponSrl,
    couponType,
    maxAmount,
    discountAmount,
    discountPercent,
    issued,
    groupSeqNo,
  } = coupon;

  return (
    <div className="info_unit_bind">
      <div className="partner_burden">
        <PartnerBurdenText
          price={price}
          maxAmount={maxAmount}
          discountAmount={discountAmount}
          discountPercent={discountPercent}
          couponType={couponType}
          isSkim={isSkim}
        />
        <PartnerBurdenButton
          groupSeqNo={groupSeqNo}
          couponSrl={couponSrl}
          issuedButton={issued || issueCouponData.issued}
          issueCouponData={issueCouponData}
          setIsToast={setIsToast}
        />
      </div>
      {isToast && <PartnerBurdenToast resultMsg={issueCouponData.resultMsg} />}
    </div>
  );
}

CouponPartner.propTypes = {
  coupon: PropTypes.shape({}),
};

export default CouponPartner;
